// extracted by mini-css-extract-plugin
module.exports = {"items":"Item_items__PFYqw","item":"Item_item__VWp7B","date":"Item_date__1DQnP","price":"Item_price__wfa44","additional":"Item_additional__HpxfC"};